import { render, staticRenderFns } from "./NewExam.vue?vue&type=template&id=77a2c3de&scoped=true&"
import script from "./NewExam.vue?vue&type=script&lang=js&"
export * from "./NewExam.vue?vue&type=script&lang=js&"
import style0 from "./NewExam.vue?vue&type=style&index=0&id=77a2c3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2c3de",
  null
  
)

export default component.exports